import { NavigationMenuViewport } from "@radix-ui/react-navigation-menu";

export const MegaMenuViewport = () => {
  return (
    <div className="absolute left-0 right-0 top-full flex">
      <NavigationMenuViewport className="peer relative w-full overflow-hidden bg-white transition-[height] duration-300 data-[state=closed]:animate-menu-hide data-[state=open]:animate-menu-show" />
      {/* Backdrop */}
      <div className="absolute left-0 right-0 top-full hidden h-screen opacity-40 peer-data-[state=open]:block peer-data-[state=open]:bg-black" />
    </div>
  );
};
